import React, { Component } from 'react'
import BreadCrumbs from '../../../components/BreadCrumbs/BreadCrumbs'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleDown, faSearch } from '@fortawesome/free-solid-svg-icons'
import ButtonNexcareDefault from '../../../components/Button/ButtonNexcareDefault'
import ButtonBorderNexcareDefault from '../../../components/Button/ButtonBorderNexcareDefault'
import TableNexcare from '../../../components/Table/TableNexcare'
import IconActionDownload from '../../../assets/icons/IconActionDownload'
import API_CALL_HISTORY from '../../../api/apiCallHistory'
import { errorHandler, getContent } from '../../../util/responseUtil'
import ActionType from '../../../redux/reducer/globalActionType'
import { connect } from 'react-redux'
import { ROUTER_CONSTANT } from '../../../constants/routerConstant'
import Accordion from '../../../components/Accordion/Accordion'
import IconReload from '../../../assets/icons/IconReload'
import DateRange from '../../../components/DateRange/DateRange'
import { SETTING_CALL_HISTORY_VIEW, SETTING_CALL_HISTORY_VIEW_ASSIGNEE } from '../../../constants/menuPermissionConstant'
import { CheckPermissionComponent } from '../../../util/permission'
import axios from 'axios'

/**
 * Search By
 */
const SEARCH_BY_TICKET_NO = 'ticket_no'
const SEARCH_BY_CALLER = 'sender.first_name'

/**
 * Call Statuses
 */
const CALL_STATUS_INCOMING = 'Masuk'
const CALL_STATUS_OUTGOING = 'Keluar'
const CALL_STATUS_NOT_ANSWERED = 'Tak Terjawab'

/**
 * CS Statuses
 */
const CS_STATUS_ACTIVE = 'true'
const CS_STATUS_INACTIVE = 'false'

/**
 * Fields
 */
const FIELD_CALL_AT = 'call_logging.call_at'
const FIELD_CALLER = 'sender.first_name'
const FIELD_RECEIVER = 'receiver.first_name'
const FIELD_TICKET_NO = 'ticket.ticket_no'
const FIELD_CALL_STATUS = 'call_logging.call_status'
const FIELD_DURATION = 'call_logging.duration'

const columnsCallHistory = [
    {
        title: "Tanggal & waktu",
        dataIndex: "call_at",
        headerAlign: "justify-start",
        bodyAlign: "text-left",
        sorter: true,
        render: (data) => {
            const date = new Date(data)

            let day = appendZero(date.getUTCDate())
            let month = appendZero(date.getUTCMonth() + 1)
            let hours = appendZero(date.getUTCHours())
            let minutes = appendZero(date.getUTCMinutes())

            let result = `${day}/${month}/${date.getUTCFullYear()} | ${hours}:${minutes}`
            return result
        },
    },
    {
        title: "Penelpon",
        dataIndex: "call_outgoing_name",
        headerAlign: "justify-start",
        bodyAlign: "text-left",
        sorter: true,
        render: (data) => `${data}`,
    },
    {
        title: "Penerima",
        dataIndex: "call_incoming_name",
        headerAlign: "justify-start",
        bodyAlign: "text-left",
        sorter: true,
        render: (data) => `${data}`,
    },
    {
        title: "Nomor Tiket",
        dataIndex: "ticket_no",
        headerAlign: "justify-start",
        bodyAlign: "text-left",
        sorter: true,
        render: (data) => `${data}`,
    },
    {
        title: "Status Panggilan",
        dataIndex: "call_status",
        headerAlign: "justify-start",
        bodyAlign: "text-left",
        sorter: true,
        render: (data) => {
            let color = ''

            if (data === CALL_STATUS_INCOMING) {
                color = '--nexcare-green-2'
            }

            if (data === CALL_STATUS_NOT_ANSWERED) {
                color = '--nexcare-red-2'
            }

            if (data === CALL_STATUS_OUTGOING) {
                color = '--nexcare-blue-6'
            }

            return (
                <div className={`relative w-max py-0.5 px-3 z-10`} style={{ color: `var(${color})` }}>
                    <div className={`absolute top-0 left-0 right-0 bottom-0 opacity-10 rounded-full`} style={{ zIndex: '-1', backgroundColor: `var(${color})` }}></div>
                    <span>{data}</span>
                </div>
            )
        },
    },
    {
        title: "Durasi",
        dataIndex: "duration",
        headerAlign: "justify-start",
        bodyAlign: "text-left",
        sorter: true,
        render: (data) => `${data}`,
    },
    {
        title: "Aksi",
        dataIndex: "link_call_record",
        headerAlign: "justify-start",
        bodyAlign: "text-left",
        render: (data) => {
            if (!data) {
                return null
            }

            return (
                <button type='button' onClick={() => downloadRecordingFile(data)}>
                    <IconActionDownload />
                </button>
            )
        },
    },
];

/**
 * 
 * @param {string} url 
 */
const downloadRecordingFile = (url = '') => {
    const config = {
        responseType: 'blob',
    }

    axios.get(url, config)
        .then(res => {
            const separatedUrl = url.split('/')
            const fileName = separatedUrl[separatedUrl.length - 1]
            const href = window.URL.createObjectURL(res.data)
            const a = document.createElement('a')

            a.href = href
            a.download = fileName

            a.click()

            window.URL.revokeObjectURL(href)
        })
        .catch(() => alert('Download file gagal'))
}

const appendZero = (number) => {
    if (number < 10) {
        return "0" + number
    }

    return number
}

/**
 * Order by fields
 */
const orderByFields = [
    {
        field: 'call_at',
        alias: FIELD_CALL_AT
    },
    {
        field: 'call_outgoing_name',
        alias: FIELD_CALLER
    },
    {
        field: 'call_incoming_name',
        alias: FIELD_RECEIVER
    },
    {
        field: 'ticket_no',
        alias: FIELD_TICKET_NO
    },
    {
        field: 'call_status',
        alias: FIELD_CALL_STATUS
    },
    {
        field: 'duration',
        alias: FIELD_DURATION
    },
]


class CallHistory extends Component {
    constructor(props) {
        super(props)

        /**
         * @type {React.RefObject<HTMLDivElement>}
         */
        this.accordionFilterRef = React.createRef()

        /**
         * @type {React.RefObject<HTMLDivElement>}
         */
        this.filterOpenerRef = React.createRef()
        this.state = {
            callHistory: {
                pagination: {
                    current: 1,
                    pageSize: 10,
                    total: 0,
                },
                keyword: '',
                searchBy: SEARCH_BY_TICKET_NO,
                orderBy: '',
                cs: {
                    csList: [],
                    keyword: '',
                    selectedCSId: null
                },
                csActive: '',
                callStatus: '',
                date: {
                    startDate: '',
                    endDate: ''
                },
                data: [],
            },
            isFilterOpen: false,
            availableSearchBy: [
                {
                    label: 'Nomor Tiket',
                    value: SEARCH_BY_TICKET_NO
                },
                {
                    label: 'Penelepon',
                    value: SEARCH_BY_CALLER
                },
            ]
        }
    }

    async componentDidMount() {
        await this.updateParams()

        this.setInitiateCallHistory()
        this.setCallHistory()
        this.setCSList()

        document.addEventListener('click', this.closeAccordionFilter)
    }

    componentDidUpdate(_, prevState) {
        if (this.state.callHistory.cs.keyword !== prevState.callHistory.cs.keyword) {
            this.setCSList()
        }

        if (this.state.callHistory.orderBy !== prevState.callHistory.orderBy) {
            this.setCallHistory()
        }

        if (this.state.callHistory.csActive !== prevState.callHistory.csActive) {
            this.setCSList()
        }
    }

    componentWillUnmount() {
        document.removeEventListener('click', this.closeAccordionFilter)
    }

    closeAccordionFilter = (e) => {
        if (!this.accordionFilterRef.current) {
            return
        }

        if (this.filterOpenerRef.current.contains(e.target)) {
            return
        }

        if (!this.accordionFilterRef.current.contains(e.target)) {
            this.setState({
                isFilterOpen: false
            })
        }
    }

    /**
    * @returns {{
    *  page: string,
    *  limit: string,
    *  keyword: string,
    *  searchBy: string,
    *  orderBy: string,
    *  csKeyword: string,
    *  csId: string,
    *  callStatus: string,
    *  startDate: string,
    *  endDate: string
    * }}
    */
    getParams = () => {
        const url = new URL(document.location.href)

        return {
            page: url.searchParams.get("page") || '',
            limit: url.searchParams.get("limit") || '',
            keyword: url.searchParams.get("keyword") || '',
            orderBy: url.searchParams.get("orderBy") || '',
            csKeyword: url.searchParams.get("csKeyword") || '',
            csId: url.searchParams.get("csId") || '',
            callStatus: url.searchParams.get("callStatus") || '',
            csActive: url.searchParams.get("csActive") || '',
            startDate: url.searchParams.get("startDate") || '',
            endDate: url.searchParams.get("endDate") || ''
        }
    }

    updateParams = () => {
        const url = new URL(document.location.href)
        const params = this.getParams()

        let isValid = true

        let page = parseInt(params.page)
        let limit = parseInt(params.limit)

        if (!page) {
            isValid = false
            url.searchParams.set('page', '1')
        }

        if (!limit) {
            isValid = false
            url.searchParams.set('limit', '10')
        }

        if (params.csId) {
            if (!parseInt(params.csId)) {
                isValid = false
                url.searchParams.delete('csId')
            }
        }

        if (!isValid) {
            return this.props.history.push(`${ROUTER_CONSTANT.SETTINGS_CALL_HISTORY}${url.search}`)
        }

        return this.setState({
            callHistory: {
                ...this.state.callHistory,
                pagination: {
                    ...this.state.callHistory.pagination,
                    current: parseInt(params.page),
                    pageSize: parseInt(params.limit)
                },
                keyword: params.keyword,
                searchBy: params.searchBy || SEARCH_BY_TICKET_NO,
                cs: {
                    ...this.state.callHistory.cs,
                    keyword: params.csKeyword,
                    selectedCSId: parseInt(params.csId) || null
                },
                callStatus: params.callStatus,
                csActive: params.csActive,
                date: {
                    startDate: params.startDate,
                    endDate: params.endDate
                },
            }
        })
    }

    setCallHistory = async () => {
        const callHistory = this.state.callHistory
        const filter = {
            csList: callHistory.cs.selectedCSId || '',
            callStatus: callHistory.callStatus,
            csActive: callHistory.csActive,
            date: {
                start_date: callHistory.date.startDate,
                end_date: callHistory.date.endDate
            }
        }
        const callHistoryRes = await this.getCallHistoryList(
            callHistory.pagination.current, callHistory.pagination.pageSize, callHistory.searchBy,
            callHistory.keyword, filter, callHistory.orderBy, this.props.token
        )
        if (!callHistoryRes) {
            return
        }

        const callHistoryList = getContent(callHistoryRes) || []

        this.setState({
            callHistory: {
                ...this.state.callHistory,
                data: callHistoryList
            }
        })
    }

    setInitiateCallHistory = async () => {
        const callHistory = this.state.callHistory
        const filter = {
            csList: callHistory.cs.selectedCSId || '',
            callStatus: callHistory.callStatus,
            csActive: callHistory.csActive,
            date: {
                start_date: callHistory.date.startDate,
                end_date: callHistory.date.endDate
            }
        }
        const initiateCallHistory = await this.getInitiateCallHistory(callHistory.searchBy, callHistory.keyword, filter)
        if (!initiateCallHistory) {
            return
        }

        const data = getContent(initiateCallHistory)

        this.setState({
            callHistory: {
                ...this.state.callHistory,
                pagination: {
                    ...this.state.callHistory.pagination,
                    total: data.count_data
                }
            }
        })
    }

    setCSList = async () => {
        const res = await this.getListCS(1, 100, this.state.callHistory.csActive, {
            name: this.state.callHistory.cs.keyword
        })
        if (!res) {
            return
        }

        const csList = getContent(res) || []

        this.setState({
            callHistory: {
                ...this.state.callHistory,
                cs: {
                    ...this.state.callHistory.cs,
                    csList: csList
                }
            }
        })
    }

    /** 
     * @param {{ csList: string, callStatus: string, csActive: string, date: { start_date: string, end_date: string }}|null} filter
     */
    getCallHistoryList = (page = 1, limit = 10, searchBy = '', keyword = '', filter = null, orderBy = '') => {
        return API_CALL_HISTORY.getListCallHistory(page, limit, searchBy, keyword, filter, orderBy, this.props.token)
            .then((res) => res)
            .catch(errorHandler(this.props.handleLogout, this.props.history))
    }

    /** 
     * @param {{ csList: string, callStatus: string, csActive: string, date: { start_date: string, end_date: string }}|null} filter
     */
    getInitiateCallHistory = (searchBy = '', keyword = '', filter = null) => {
        return API_CALL_HISTORY.getInitiateCallHistory(searchBy, keyword, filter, this.props.token)
            .then((res) => res)
            .catch(errorHandler(this.props.handleLogout, this.props.history))
    }

    /** 
     * @param {{ name: string }|null} filter
     */
    getListCS = (page = 1, limit = 100, csActive = '', filter = null) => {
        return API_CALL_HISTORY.getListUserCS(page, limit, csActive, filter, this.props.token)
            .then(res => res)
            .catch(errorHandler(this.props.handleLogout, this.props.history))
    }

    /**
     * @param {Object}
     */
    pushQueryParams = (params = null) => {
        if (!params || Object.keys(params).length === 0) {
            return
        }

        const url = new URL(document.location.href)

        for (const key in params) {
            url.searchParams.set(key, params[key])
        }

        this.props.history.push(`${ROUTER_CONSTANT.SETTINGS_CALL_HISTORY}${url.search}`)
    }

    /**
     * @param {string} params
     */
    deleteQueryParams = (...params) => {
        if (!params || Object.keys(params).length === 0) {
            return
        }

        const url = new URL(document.location.href)

        for (const param of params) {
            url.searchParams.delete(param)
        }

        this.props.history.push(`${ROUTER_CONSTANT.SETTINGS_CALL_HISTORY}${url.search}`)
    }

    handleSelectedPage = async page => {
        this.pushQueryParams({ page })

        await this.updateParams()

        this.setCallHistory()
    }

    handleSelectedPageSize = async (pageSize) => {
        pageSize = parseInt(pageSize)

        const totalPage = Math.ceil(this.state.callHistory.pagination.total / pageSize)
        const params = {
            limit: pageSize
        }

        if (this.state.callHistory.pagination.current > totalPage) {
            params.page = totalPage
        }

        this.pushQueryParams(params)

        await this.updateParams()

        this.setCallHistory()
    }

    handleKeywordChange = (e) => {
        this.setState({
            callHistory: {
                ...this.state.callHistory,
                keyword: e.target.value
            }
        })
    }

    handleSearchByChange = (data) => {
        this.setState({
            callHistory: {
                ...this.state.callHistory,
                searchBy: data.value
            }
        })
    }

    handleSearch = async (e) => {
        e.preventDefault()

        this.pushQueryParams({
            page: 1,
            keyword: this.state.callHistory.keyword,
            searchBy: this.state.callHistory.searchBy,
        })

        await this.updateParams()

        this.setCallHistory()
        this.setInitiateCallHistory()

        this.setState({
            isFilterOpen: false
        })
    }

    handleCSKeywordChange = (e) => {
        this.setState({
            callHistory: {
                ...this.state.callHistory,
                cs: {
                    ...this.state.callHistory.cs,
                    keyword: e.target.value,
                }
            }
        })
    }

    handleSelectCS = (id) => {
        if (id === this.state.callHistory.cs.selectedCSId) {
            id = null
        }

        this.setState({
            callHistory: {
                ...this.state.callHistory,
                cs: {
                    ...this.state.callHistory.cs,
                    selectedCSId: id
                }
            }
        })
    }

    handleSelectCSStatus = (e) => {
        let value = e.target.value

        if (!e.target.checked) {
            value = ''
        }

        this.setState({
            callHistory: {
                ...this.state.callHistory,
                csActive: value
            }
        })
    }

    handleSelectCallStatus = (e) => {
        let value = e.target.value

        if (!e.target.checked) {
            value = ''
        }

        this.setState({
            callHistory: {
                ...this.state.callHistory,
                callStatus: value
            }
        })
    }

    handleDateChange = (from, to) => {
        const startDate = new Date(from)
        const endDate = new Date(to)

        from = `${startDate.getFullYear()}-${appendZero(startDate.getUTCMonth() + 1)}-${appendZero(startDate.getUTCDate())}`
        to = `${endDate.getFullYear()}-${appendZero(endDate.getUTCMonth() + 1)}-${appendZero(endDate.getUTCDate())}`

        this.setState({
            callHistory: {
                ...this.state.callHistory,
                date: {
                    startDate: from,
                    endDate: to
                }
            }
        })
    }

    handleFilter = async () => {
        this.pushQueryParams({
            page: 1,
            csKeyword: this.state.callHistory.cs.keyword,
            csId: this.state.callHistory.cs.selectedCSId || '',
            callStatus: this.state.callHistory.callStatus,
            csActive: this.state.callHistory.csActive,
            startDate: this.state.callHistory.date.startDate,
            endDate: this.state.callHistory.date.endDate,
        })

        await this.updateParams()

        this.setCallHistory()
        this.setInitiateCallHistory()

        this.setState({
            isFilterOpen: false
        })
    }

    resetFilter = async () => {
        this.deleteQueryParams("keyword", "searchBy", "csKeyword", "csId", "callStatus", "csActive", "startDate", "endDate")
        this.pushQueryParams({ page: 1 })

        await this.updateParams()

        this.setCallHistory()
        this.setInitiateCallHistory()

        this.setState({
            isFilterOpen: false
        })
    }

    handleResetSearch = async () => {
        this.resetFilter()
    }

    handleSorter = (sorter) => {
        const orderBy = orderByFields.find(data => data.field === sorter.field)

        let orderByResult = ''

        if (sorter.ascending) {
            orderByResult = 'ASC'
        }

        if (sorter.descending) {
            orderByResult = 'DESC'
        }

        if (orderByResult) {
            orderByResult = `${orderBy.alias} ${orderByResult}`
        }

        this.setState({
            callHistory: {
                ...this.state.callHistory,
                orderBy: orderByResult
            }
        })
    }

    render() {
        console.log(this.state.callHistory)
        return (
            <CheckPermissionComponent permissionConstant={[SETTING_CALL_HISTORY_VIEW, SETTING_CALL_HISTORY_VIEW_ASSIGNEE]} userPermission={this.props.userDetail.permissions}>
                <div className="call-history h-full pb-5">
                    <BreadCrumbs
                        parentMenu="Pengaturan"
                        serviceMenu="Riwayat Panggilan"
                        title="Riwayat Panggilan"
                    />
                    <div className="mt-3 h-content">
                        <form className='flex items-stretch gap-5 mb-5' onSubmit={this.handleSearch}>
                            <div className="flex items-center relative w-1/6">
                                <input
                                    type="text"
                                    id="tslkeyword"
                                    className="custom-form-control w-full h-full pl-3 pr-8"
                                    placeholder="Nomor Tiket"
                                    autoComplete="off"
                                    value={this.state.callHistory.keyword}
                                    onChange={this.handleKeywordChange}
                                />
                                <FontAwesomeIcon icon={faSearch} className="absolute right-3 text-gray-500" />
                            </div>
                            <div className='flex items-center gap-5'>
                                <ButtonBorderNexcareDefault id="btnreset" type="button" onClick={this.handleResetSearch}>Atur Ulang</ButtonBorderNexcareDefault>
                                <ButtonNexcareDefault id="btnsearch" type="submit">Cari</ButtonNexcareDefault>
                                <button
                                    id="btnreload"
                                    className="bg-lightblue rounded h-full text-white cursor-pointer py-2 px-4 text-lg"
                                    type="button"
                                    onClick={() => window.location.reload()}
                                >
                                    <IconReload style={{ width: '1.5rem', height: '1.6rem' }} />
                                </button>
                            </div>
                        </form>
                        <div className='relative w-1/6 mb-5'>
                            <div className="flex items-center relative">
                                <div
                                    type="text"
                                    id="filter"
                                    className="custom-form-control select-none cursor-pointer text-gray-400 w-full h-full py-2.5 pl-3 pr-8 bg-white hover:border-nexcaredefault"
                                    onClick={() => this.setState({ isFilterOpen: !this.state.isFilterOpen })}
                                    ref={this.filterOpenerRef}
                                >
                                    Filter
                                </div>
                                <FontAwesomeIcon icon={faAngleDown} className={`absolute right-3 pointer-events-none transform ${this.state.isFilterOpen ? 'rotate-180' : ''}`} />
                            </div>
                            <div
                                className={`filter absolute mt-1 top-full left-0 right-0 bg-nexcarewhite4 shadow-lg rounded-md overflow-hidden pb-3 transition duration-150 transform ${this.state.isFilterOpen ? '' : 'pointer-events-none opacity-0 translate-y-5'}`}
                                ref={this.accordionFilterRef}
                            >
                                <CheckPermissionComponent permissionConstant={[SETTING_CALL_HISTORY_VIEW]} userPermission={this.props.userDetail.permissions}>
                                    <Accordion title='Status CS' headerClassName='bg-nexcarewhite4'>
                                        <div className='text-sm'>
                                            <label htmlFor='cbCSActive' className='flex justify-between py-2 px-2.5 hover:bg-nexcarewhite1 cursor-pointer select-none'>
                                                <span>Aktif</span>
                                                <input
                                                    id='cbCSActive'
                                                    type="checkbox"
                                                    value={CS_STATUS_ACTIVE}
                                                    onChange={this.handleSelectCSStatus}
                                                    checked={this.state.callHistory.csActive === CS_STATUS_ACTIVE}
                                                />
                                            </label>
                                            <label htmlFor='cbCSInactive' className='flex justify-between py-2 px-2.5 hover:bg-nexcarewhite1 cursor-pointer select-none'>
                                                <span>Tidak Aktif</span>
                                                <input
                                                    id='cbCSInactive'
                                                    type="checkbox"
                                                    value={CS_STATUS_INACTIVE}
                                                    onChange={this.handleSelectCSStatus}
                                                    checked={this.state.callHistory.csActive === CS_STATUS_INACTIVE}
                                                />
                                            </label>
                                        </div>
                                    </Accordion>
                                    <Accordion title='Nama CS' headerClassName='bg-nexcarewhite4'>
                                        <div className='text-sm'>
                                            <div className='bg-nexcarewhite1 py-2 px-2.5'>
                                                <div className="flex items-center bg-white">
                                                    <input
                                                        type="text"
                                                        className="w-full py-1 px-2 outline-none"
                                                        placeholder="Masukkan Nama"
                                                        value={this.state.callHistory.cs.keyword}
                                                        onChange={this.handleCSKeywordChange}
                                                    />
                                                    <FontAwesomeIcon icon={faSearch} className="pr-2 text-gray-400" />
                                                </div>
                                            </div>
                                            <div className='cs-list list-none overflow-auto' style={{ maxHeight: '200px' }}>
                                                {
                                                    this.state.callHistory.cs.csList.map((data) => (
                                                        <div
                                                            key={data.user_nexcare_id}
                                                            onClick={() => this.handleSelectCS(data.user_nexcare_id)}
                                                            className={`py-2 px-2.5 hover:bg-nexcarewhite1 cursor-pointer select-none ${this.state.callHistory.cs.selectedCSId === data.user_nexcare_id ? 'font-bold' : ''}`}
                                                        >
                                                            {data.name}
                                                        </div>
                                                    ))
                                                }
                                            </div>
                                        </div>
                                    </Accordion>
                                </CheckPermissionComponent>
                                <Accordion title='Panggilan' headerClassName='bg-nexcarewhite4'>
                                    <div className='text-sm'>
                                        <label htmlFor='cbOutgoingCall' className='flex justify-between py-2 px-2.5 hover:bg-nexcarewhite1 cursor-pointer select-none'>
                                            <span>Panggilan Keluar</span>
                                            <input
                                                id='cbOutgoingCall'
                                                type="checkbox"
                                                value={CALL_STATUS_OUTGOING}
                                                onChange={this.handleSelectCallStatus}
                                                checked={this.state.callHistory.callStatus === CALL_STATUS_OUTGOING}
                                            />
                                        </label>
                                        <label htmlFor='cbNotAnswered' className='flex justify-between py-2 px-2.5 hover:bg-nexcarewhite1 cursor-pointer select-none'>
                                            <span>Tak Terjawab</span>
                                            <input
                                                id='cbNotAnswered'
                                                type="checkbox"
                                                value={CALL_STATUS_NOT_ANSWERED}
                                                onChange={this.handleSelectCallStatus}
                                                checked={this.state.callHistory.callStatus === CALL_STATUS_NOT_ANSWERED}
                                            />
                                        </label>
                                    </div>
                                </Accordion>
                                <Accordion title='Tanggal' headerClassName='bg-nexcarewhite4' maxHeight={350}>
                                    <div className='text-sm'>
                                        <DateRange
                                            from={this.state.callHistory.date.startDate ? new Date(this.state.callHistory.date.startDate) : undefined}
                                            to={this.state.callHistory.date.endDate ? new Date(this.state.callHistory.date.endDate) : undefined}
                                            getDateRange={this.handleDateChange}
                                            showButton={false}
                                        />
                                    </div>
                                </Accordion>
                                <div className='flex justify-between items-center gap-3 filter-cta px-2.5 mt-3'>
                                    <ButtonNexcareDefault id="btnfilter" className="w-full" type="button" onClick={this.handleFilter}>Terapkan</ButtonNexcareDefault>
                                </div>
                            </div>
                        </div>
                        <div className='call-history-list bg-white rounded-2xl'>
                            <TableNexcare
                                column={columnsCallHistory}
                                dataTable={this.state.callHistory.data}
                                pagination={this.state.callHistory.pagination}
                                onPage={this.handleSelectedPage}
                                onPageSize={this.handleSelectedPageSize}
                                onSorter={this.handleSorter}
                                halfBodyHeight
                            />
                        </div>
                    </div>
                </div>
            </CheckPermissionComponent>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        token: state.authentication.token,
        userDetail: state.authentication.userDetail
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        handleLogout: () => dispatch({ type: ActionType.IS_LOGOUT })
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(CallHistory);